import React, { useState, useEffect } from "react";
import { useUser } from "../../Context/UserContext"; // Usamos el contexto del usuario
import { FaBars, FaTimes } from "react-icons/fa"; // Import icons for hamburger and close
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_LINKS = [
  { to: "/", label: "Inicio" },
  { to: "/catalogo", label: "Catálogo" },
  { to: "/kits", label: "Kits" },
  { to: "/servicios", label: "Servicios" },
  { to: "/insignia", label: "Productos Insignia" },
  { to: "/Volteon", label: "Somos Volteon" },
];

const NavLinks = ({ currentPath, onLinkClick, user, onLogout }) => (
  <>
    {NAV_LINKS.map(({ to, label }) => (
      <li className="nav-item" key={to}>
        <Link
          to={to}
          onClick={onLinkClick}
          className={currentPath === to ? "active" : ""}
        >
          {label}
        </Link>
      </li>
    ))}

    {user ? (
      <>
        <li className="nav-item">
          <Link to="/perfil" className="user-name">
            {user.name.split(" ").slice(0, 2).join(" ")}
          </Link>
        </li>
        <button className="btn-container login-btn-container" onClick={onLogout}>
          Cerrar sesión
        </button>
      </>
    ) : (
      <>
        <Link to="/iniciar-sesion" className="btn-container login-btn-container">
          Iniciar sesión
        </Link>
        <Link to="/crear-cuenta" className="btn-container signup-btn-container">
          Crear cuenta
        </Link>
        <Link to="/perfil" className="icon-container navbar-icon-container" />
      </>
    )}
  </>
);

const Header = () => {
  const [click, setClick] = useState(false); // State to toggle sidebar
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si estamos cargando la sesión
  const navigate = useNavigate(); // Hook de navegación
  const { pathname } = useLocation();

  const { user, setUser } = useUser(); // Obtenemos el usuario del contexto

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false); // Una vez que termine la carga, actualizamos isLoading
  }, [setUser]);

  const handleClick = () => setClick(!click); // Toggle sidebar
  const closeMenu = () => setClick(false); // Close sidebar

  const handleLogout = () => {
    setUser(null); // Limpiar el usuario del contexto al hacer logout
    localStorage.removeItem("user"); // Limpiar el usuario del localStorage
    window.location.href = "/"; // Redirigir al inicio
  };

  if (isLoading) {
    return <div>Cargando...</div>; // O puedes poner un componente de carga aquí
  }

  return (
    <div className="header-container">
      <nav className="navbar-container">
        {/* Logo */}
        <div className="logo-container">
          <span className="logo-wrapper">
            <Link to="/" className="logo">
              <img
                src="/images/logo_leon.png"
                alt="Logo León"
                className="logo-leon"
              />
              <img
                src="/images/logo_letras.png"
                alt="Logo Letras"
                className="logo-letras"
              />
            </Link>
          </span>
        </div>

        {/* Hamburger Menu Icon (Mobile Only) */}
        <button
          className="mobile-menu-icon"
          onClick={handleClick}
          aria-label={click ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={click}
        >
          {click ? <FaTimes className="icon" /> : <FaBars className="icon" />}
        </button>

        {/* Regular Menu (Desktop) */}
        <ul className="nav-menu-container">
          <NavLinks
            currentPath={pathname}
            onLinkClick={closeMenu}
            user={user}
            onLogout={handleLogout}
          />
        </ul>

        <div className={`sidebar ${click ? "active" : ""}`}>
          <ul className="nav-menu-container">
            <NavLinks
              currentPath={pathname}
              onLinkClick={closeMenu}
              user={user}
              onLogout={handleLogout}
            />
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Header;
